import { Enrollment } from 'ef/models/enrollment';
import EF from 'ef/ef';
import _ from 'lodash';

const getParams = () => {
  let match;
  const params = new Map(),
    pl = /\+/g,
    search = /([^&=]+)=?([^&]*)/g,
    decode = function (s) {
      return decodeURIComponent(s.replace(pl, ' '));
    },
    query = new URLSearchParams(window.location.search || '').toString(),
    parse = function (val) {
      try {
        val = JSON.parse(val);
      } catch (e) {
        // eslint-disable-next-line
        val = val;
      }
      return val;
    };

  while ((match = search.exec(query))) {
    const key = decode(match[1]);
    const value = parse(decode(match[2]));

    params.set(key, value);
  }
  return Object.fromEntries(params.entries());
};

export default class UrlHelper {
  constructor() {
    this.params = getParams();
  }

  getParam(key, defaultKey) {
    return this.params[key] || defaultKey;
  }

  buildEnrollment(enrollmentHash) {
    const attrs = ['id', 'userId', 'cohortId', 'schoolId', 'name', 'schoolName', 'className', 'state', 'certified'];
    enrollmentHash = _.defaults(_.pick(this.params, attrs), enrollmentHash);
    return new Enrollment(enrollmentHash);
  }

  buildConfig(moreAttrs) {
    const attrs = ['assessmentEndpoint', 'basePath', 'stage', 'demoMode'];
    const config = _.defaults(_.pick(this.params, attrs), moreAttrs);
    return new EF.Config(config);
  }

  buildOptions(moreAttrs) {
    const attrs = ['pmMode', 'local', 'apiOnly', 'loadCustomizationsRemote'];
    return _.defaults(_.pick(this.params, attrs), moreAttrs);
  }
}
